import InfoIcon from '@mui/icons-material/Info';
import { InputLabel, Select, Stack, Tooltip } from '@mui/material';
import * as React from 'react';
import variable from '../style/variable';

interface IDropDownProps {
    id?: string;
    name?: string;
    label?: string;
    value?: any;
    labelId?: string;
    disabled?: boolean;
    hidden?: boolean;
    multiple?: boolean;
    renderValue?: any;
    onChange?: (e: any) => void;
    children?: React.ReactNode;
    textTooltip?: string;
    required?: boolean;
}

const DropDown = (props: IDropDownProps) =>
    !props.hidden && (
        <Stack padding={'0.3rem 0rem'} spacing={0.5} flex={1}>
            {props.textTooltip ? (
                <Stack direction={'row'} spacing={1} alignItems={'center'}>
                    <InputLabel required={props.required} style={{ fontSize: '0.8rem' }}>
                        {props.label}
                    </InputLabel>
                    <Tooltip title={props.textTooltip}>
                        <InfoIcon style={{ fill: variable.green, height:'18px' }} fontSize='medium' />
                    </Tooltip>
                </Stack>
            ) : (
                <InputLabel required={props.required} style={{ fontSize: '0.8rem' }}>
                    {props.label}
                </InputLabel>
            )}
            <Select
                multiple={props.multiple}
                disabled={props.disabled}
                required={props.required}
                id={props.id}
                name={props.name}
                value={props.value}
                renderValue={props.renderValue}
                onChange={props.onChange}>
                {props.children}
            </Select>
        </Stack>
    );

export default DropDown;
